import { previewSelectItems } from "#/admin/legacy/form-builder/preview-select-items.js";

class FormBuilderFormPreview {
  constructor(fixedChoiceOptions = {}) {
    this.fixedChoiceOptions = fixedChoiceOptions;
    this.el = jQuery('<div class="form-builder-preview" data-behaviour="form-builder-preview"></div>');
    var self = this;

    // BEHAVIOUR

    this.el.on("click", "[data-behaviour=editable-field]", function (e) {
      self.showFieldEditorHandler(e, this);
    });
    this.el.on("click", "[data-behaviour=submit-field]", function (e) {
      self.showSubmitEditorHandler(e, this);
    });
    this.el.on("click", ".form-field-template-item-delete", function (e) {
      self.deleteFieldHandlerFromPreview(e, this);
    });
  }

  render(formTemplate) {
    var formTemplate = jQuery.extend({ submit_text: "Submit" }, formTemplate);

    formTemplate.fields = formTemplate.fields.map((field) => previewSelectItems(field, this.fixedChoiceOptions));

    this.el.html(Sparkle.HandlebarsTemplates["form-builder-preview"](formTemplate));
  }

  // EVENT HANDLERS

  deleteFieldHandlerFromPreview(e, item) {
    e.preventDefault();
    item = jQuery(item).closest("[data-behaviour=editable-field]");
    this.el.trigger("FB:deleteField", [item]);
  }

  showFieldEditorHandler(e, item) {
    e.preventDefault();
    if (jQuery(e.target).closest(".form-field-template-item-delete").length > 0) {
      return;
    }
    this.el.trigger("FB:showFieldEditor", [item]);
  }

  showSubmitEditorHandler(e, item) {
    e.preventDefault();
    this.el.trigger("FB:showFieldEditor", [item, true]);
  }
}

window.FormBuilderFormPreview = FormBuilderFormPreview;
